import { render, staticRenderFns } from "./WorkflowRunHistory.vue?vue&type=template&id=64001284"
import script from "./WorkflowRunHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowRunHistory.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRunHistory.vue?vue&type=style&index=0&id=64001284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports